<template>
  <div v-show="isVisible">
    <alert-window ref="alertWindow"></alert-window>
    <div class="title">Описание услуги:</div>
    <div class="dop-info">
      <div>
        <div class="fieldset">
          <label class="fieldset-title">Время прибытия</label>
          <fieldset>
            <input type="text" class="time" placeholder="hh:mm" v-mask="'##:##'" v-model="time">
          </fieldset>
        </div>
        <div class="fieldset">
          <label class="fieldset-title">Категория</label>
          <fieldset>
            <select v-if="isNew" v-model="newGarbageRemovalService.category">
              <option disabled :value="null">-- Выбрать --</option>
              <option v-for="category in garbageRemovalCategories" :value="category">
                {{ category.name }}
              </option>
            </select>
            <select v-else v-model="garbageRemovalService.category">
              <option disabled :value="null">-- Выбрать --</option>
              <option v-for="category in garbageRemovalCategories" :value="category">
                {{ category.name }}
              </option>
            </select>
          </fieldset>
        </div>
        <div class="fieldset">
          <label class="fieldset-title">Район</label>
          <fieldset>
            <select v-if="isNew" v-model="newGarbageRemovalService.garbageDisposalDistrict">
              <option disabled :value="null">-- Выбрать --</option>
              <option v-for="district in garbageDisposalDistricts" :value="district">
                {{ district.name }}
              </option>
            </select>
            <select v-else v-model="garbageRemovalService.garbageDisposalDistrict">
              <option disabled :value="null">-- Выбрать --</option>
              <option v-for="district in garbageDisposalDistricts" :value="district">
                {{ district.name }}
              </option>
            </select>
          </fieldset>
        </div>
        <div class="fieldset">
          <label class="fieldset-title">Количество суток</label>
          <fieldset>
            <input type="number" placeholder="1" v-model="dayCount">
          </fieldset>
        </div>
      </div>
    </div>
    <div class="title">Адреса:</div>
    <div class="address-section">
      <div class="selected-address-form" v-show="garbageRemovalServiceAddresses.length > 0">
        <div class="fieldset">
          <draggable v-model="garbageRemovalServiceAddresses">
            <div class="address" v-for="address in garbageRemovalServiceAddresses">
              <fieldset class="address-fieldset">
                <input type="text" :value="displayAddress(address)" readonly>
              </fieldset>
              <span class="move-button" title="Переместить"><img src="../image/move.svg"></span>
            </div>
          </draggable>
        </div>
      </div>
      <div class="fieldset select-address-button">
        <div class="add-address" @click="showAddressesFromOrder = true"><span
          class="icon">+</span>Выбрать адреса
        </div>
      </div>
      <div class="select-address-form" v-show="showAddressesFromOrder">
        <div class="fieldset">
          <div class="address" v-for="(address, index) in addressesFromOrder">
            <fieldset class="address-fieldset">
              <input type="text" :value="displayAddress(address)" readonly>
            </fieldset>
            <label class="checkbox-label"><input type="checkbox" @change="addOrRemoveAddress(index, $event)"
                                                 v-model="checkboxesForAddressesFromOrder[index]">выбрать</label>
          </div>
        </div>
        <div class="buttons">
          <button type="button" @click="showAddressesFromOrder = false">Готово</button>
        </div>
      </div>
    </div>
    <div class="buttons">
      <button type="button" class="save-button" @click="saveChanges">Сохранить</button>
    </div>
  </div>
</template>
<script>
  import api from '@/api'
  import draggable from 'vuedraggable'
  import Timepicker from 'vue2-timepicker'
  import utils from '@/utils'
  import {mask} from 'vue-the-mask'
  import AlertWindow from '@/components/AlertWindow.vue'

  export default {
  name: 'GarbageRemovalService',
  props: ['isVisible', 'index', 'isNew', 'count', 'addressesFromOrder', 'orderDateTime'],

  components: {
    Timepicker,
    draggable,
    AlertWindow
  },

  directives: { mask },

  data () {
    return {
      newGarbageRemovalService: {
        type: 'OrderToGarbage',
        pathToClass: 'ru.itbrick.shustrikoffcrm.beans.OrderToGarbage',
        category: null,
        garbageDisposalDistrict: null,
        date: 0,
        dayCount: 1
      },

      garbageRemovalService: {
        category: null,
        garbageDisposalDistrict: null,
        date: 0,
        dayCount: 1
      },

      garbageRemovalCategories: [],
      garbageDisposalDistricts: [],
      garbageRemovalServiceAddresses: [],
      showAddressesFromOrder: false,
      checkboxesForAddressesFromOrder: []
    }
  },

  computed: {
    currentService: {
      get () {
        return this.isNew
          ? this.newGarbageRemovalService
          : this.garbageRemovalService
      },

      set (service) {
        if (this.isNew) {
          this.newGarbageRemovalService = service
        } else {
          this.garbageRemovalService = service
        }
      }
    },

    time: {
      get () {
        return utils.getFormattedTimeStringFromLongWithoutTimezone(this.currentService.date)
      },

      set (value) {
        if (value.length == 5) {
          let date = new Date(this.currentService.date)
          date.setHours(0, 0, 0, 0)
          this.currentService.date = new Date(date.getTime() + utils.getLongFromFormattedTimeString(value)).getTime()
        }
      }
    },

    dayCount: {
      get () {
        return this.currentService.dayCount
      },

      set (dayCount) {
        if (dayCount < 1) { dayCount = 1 }
        this.currentService.dayCount = dayCount
      }
    },
    garbageRemovalServiceAddressesCoords () {
      return this.garbageRemovalServiceAddresses.map((address) => utils.getCoordsStringOfAddress(address))
    }
  },

  watch: {
    isVisible (val) {
      if (val) {
        if (!this.isNew) {
          this.garbageRemovalService = Object.assign({}, this.$store.getters.groupedServices[this.index][0])

          this.garbageRemovalServiceAddresses = []
          if (this.garbageRemovalService.addresses != null) {
            this.garbageRemovalServiceAddresses.push.apply(this.garbageRemovalServiceAddresses, this.garbageRemovalService.addresses)
          }

          this.checkboxesForAddressesFromOrder = this.fillAddressesFromOrderCheckboxes()
        } else {
          this.newGarbageRemovalService = {
            type: 'OrderToGarbage',
            pathToClass: 'ru.itbrick.shustrikoffcrm.beans.OrderToGarbage',
            category: this.garbageRemovalCategories[0],
            garbageDisposalDistrict: this.garbageDisposalDistricts[0],
            date: this.orderDateTime,
            dayCount: 1
          }

          if (this.$store.getters.groupedServices.length > 0) {
            let mainServices = this.$store.getters.groupedServices.filter(gs => gs[0].type != 'OrderToAdditional')
            if (mainServices.length > 0) {
              let previousService = mainServices[mainServices.length - 1][0]

              if (previousService.addresses && previousService.addresses.length > 0 && previousService.type != 'OrderToPetrol') {
                this.newGarbageRemovalService.addresses = previousService.addresses
                  .filter(address => address.lat != null && address.lng != null)
                  .map(address => Object.assign({}, address))
              }
            }
          }

          this.garbageRemovalServiceAddresses = this.newGarbageRemovalService.addresses
            ? this.newGarbageRemovalService.addresses : []
          this.checkboxesForAddressesFromOrder = this.fillAddressesFromOrderCheckboxes()
        }
      }
      this.showAddressesFromOrder = false
    }
  },

  mounted () {
    api
      .getGarbageRemovalCategories()
      .then(garbageRemovalCategories => {
        if (garbageRemovalCategories) {
          this.garbageRemovalCategories = []
          this.garbageRemovalCategories = garbageRemovalCategories
        }
      })

    api
      .getGarbageDisposalDistricts()
      .then(garbageDisposalDistricts => {
        if (garbageDisposalDistricts) {
          this.garbageDisposalDistricts = []
          this.garbageDisposalDistricts = garbageDisposalDistricts
        }
      })
  },

  methods: {
    displayAddress (address) {
      if (!address || !address.place)
        return '';
      return utils.getSmallAddressFromFull(address.place)
          + (address.comment ? (' ' + address.comment) : '');
    },

    saveChanges () {
      if (this.garbageRemovalServiceAddresses.length === 0) {
        this.$refs.alertWindow.show('Ошибка', 'В услуге не выбран ни один адрес', false)
        return false
      }
      let promise
      if (this.isNew) {
        promise = this.addNewService()
      } else {
        promise = this.updateService()
      }
      this.$store.commit('addNewGroupedServicesPromise', promise)
      this.clearAddresses()
      this.$emit('close-window', false)
    },

    clearAddresses () {
      this.garbageRemovalServiceAddresses = []
      this.checkboxesForAddressesFromOrder = []
    },

    updateService () {
      // при коммите в store index из property является undefined
      let index = this.index
      let count = this.count

      let addresses = this.garbageRemovalServiceAddresses.map((item, i) => {
        item.orderNum = i
        return item
      })

      let serviceData = {
        addresses: addresses,
        category: this.garbageRemovalService.category,
        garbageDisposalDistrict: this.garbageRemovalService.garbageDisposalDistrict,
        date: this.garbageRemovalService.date,
        dayCount: this.dayCount,
        clientTime: 24 * 60 * 60 * 1000 * this.garbageRemovalService.dayCount
      }

      return new Promise(resolve => {
        utils.spotRegionAndDistrictByAddresses(this.garbageRemovalServiceAddresses, this.$store.getters.regions, this.$store.getters.districts)
          .then(regionDistrictData => {
            Object.assign(serviceData, regionDistrictData)

            this.$store.dispatch('updateGroupedServiceByIndex', {
              index: index,
              count: count,
              serviceData: serviceData
            }).then(() => resolve())
          })
      })
    },

    addNewService () {
      return new Promise(resolve => {
        this.newGarbageRemovalService.addresses = this.garbageRemovalServiceAddresses.map((item, i) => {
          item.id = 0
          item.orderNum = i
          return item
        })

        utils.spotRegionAndDistrictByAddresses(this.$store.getters.addresses, this.$store.getters.regions, this.$store.getters.districts)
          .then(regionDistrictData => {
            Object.assign(this.newGarbageRemovalService, regionDistrictData)

            let groupedService = []
            for (let i = 0; i < this.count; i++) { groupedService.push(Object.assign({}, this.newGarbageRemovalService)) }

            this.$store.dispatch('addNewGroupedService', groupedService).then(() => resolve())
          })
        this.newGarbageRemovalService.clientTime = 24 * 60 * 60 * 1000 * this.newGarbageRemovalService.dayCount
      })
    },

    serviceAddressesHaveAddressAlready (addressFromOrder) {
      let addressFormOrderCoords = utils.getCoordsStringOfAddress(addressFromOrder)
      return this.garbageRemovalServiceAddressesCoords.indexOf(addressFormOrderCoords) != -1
    },

    addOrRemoveAddress (index, e) {
      let tmpAddress = Object.assign({}, this.addressesFromOrder[index]);

      if (e.target.checked) {
        this.garbageRemovalServiceAddresses.push(tmpAddress)
      } else {
        let addressFormOrderCoords = utils.getCoordsStringOfAddress(tmpAddress)
        let removeAddressIndex = this.garbageRemovalServiceAddressesCoords.indexOf(addressFormOrderCoords)
        if (removeAddressIndex > -1) {
          this.garbageRemovalServiceAddresses.splice(removeAddressIndex, 1)
        }
      }
    },

    fillAddressesFromOrderCheckboxes () {
      return this.addressesFromOrder.map(addressFromOrder => {
        return this.serviceAddressesHaveAddressAlready(addressFromOrder)
      })
    }
  }
}
</script>
